import { render, staticRenderFns } from "./OvaCard.vue?vue&type=template&id=9bf9fc1a&scoped=true"
import script from "./OvaCard.vue?vue&type=script&lang=ts"
export * from "./OvaCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf9fc1a",
  null
  
)

export default component.exports